import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-leave-website-popup',
  templateUrl: './leave-website-popup.component.html',
  styleUrls: ['./leave-website-popup.component.scss']
})
export class LeaveWebsitePopupComponent implements OnInit {

  @Input() externalUrl:string;
  //Setting Default values for input properties
  @Input() popup_title:string='You are about to leave Sanofi US website';
  @Input() popup_content:string='By clicking on this link, you will be leaving this Sanofi hosted website,and,depending on the link, will be redirected to either another Sanofi website (for example, to view the Sanofi Privacy Policy) or an independent third-party website.<br /><br /> Sanofi has no control over the content or availability of third-party sites or resources that are linked to, and accepts no liability or responsibility for them or for any loss or damage that may arise from your use of them. The existence of a link between this website and any third party site or resource in no way implies that Sanofi in any way approves of the content of these sites or resources, or any use to which such content maybe put. <br /><br /> Please ensure that you read the legal and privacy policy sections of any website to which you link.';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  goToExternalSite(link){
    window.open(link, '_blank');
    this.activeModal.close();
  }

}
